import React from 'react';
import LegalDocument from './LegalDocument';
import LegalIndex from './LegalIndex';
import Subprocessors from './Subprocessors';
import { openExternalUrl } from '../utils/openExternal';

/**
 * Published policy screens. The frame keeps the screen the reader came from
 * mounted underneath, so Back does not rebuild the agent dashboard.
 */
export default function LegalPages({ page, onBack }) {
  if (page === 'index') return <LegalIndex onBack={onBack} />;
  if (page === 'privacy') return <LegalDocument doc="privacy" onBack={onBack} />;
  if (page === 'terms') return <LegalDocument doc="terms" onBack={onBack} />;
  if (page === 'refund') return <LegalDocument doc="refund" onBack={onBack} />;
  if (page === 'trial') return <LegalDocument doc="trial" onBack={onBack} />;
  if (page === 'cookies') return <LegalDocument doc="cookies" onBack={onBack} />;
  if (page === 'dpa') return <LegalDocument doc="dpa" onBack={onBack} />;
  if (page === 'disclaimers') return <LegalDocument doc="disclaimers" onBack={onBack} />;
  if (page === 'accessibility') return <LegalDocument doc="accessibility" onBack={onBack} />;
  if (page === 'dmca') return <LegalDocument doc="dmca" onBack={onBack} />;
  if (page === 'data-deletion') {
    return (
      <LegalDocument doc="deletion" onBack={onBack}>
        <button
          type="button"
          onClick={() => {
            openExternalUrl('mailto:support@pacarion.com?subject=Data%20Deletion%20Request');
          }}
          style={{
            background: '#59c4c4',
            color: 'white',
            border: 'none',
            padding: '0.75rem 1.25rem',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            marginTop: '0.5rem',
          }}
        >
          Email a deletion request
        </button>
        <p style={{ marginTop: '0.75rem' }}>support@pacarion.com</p>
      </LegalDocument>
    );
  }
  if (page === 'subprocessors') return <Subprocessors onBack={onBack} />;
  return null;
}
